export const SET_IS_PC = 'SET_IS_PC'
export const SET_IS_TABLET = 'SET_IS_TABLET'
export const SET_IS_BOT = 'SET_IS_BOT'
